import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProductConfigurableOptionsComponentDef } from '@df/catalog-ui/product/configurable-options/product-configurable-options.component.def';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'giftcards-product-configurable-options',
    templateUrl: './giftcards-product-configurable-options.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, GridModule, IfSizeDirective, TranslatePipe]
})
export class GiftcardsProductConfigurableOptionsComponent extends ProductConfigurableOptionsComponentDef {
    @Input()
    request!: Giftcards.IAddToBasketData;

    override ngOnInit() {
        super.ngOnInit();

        this.subscriptions.add(
            this.app.events.on('product-configurable-options.model-change').subscribe(() => {
                this.emitInit();
            })
        );
    }
}
